import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ADMIN_MENU_ITEMS, isAdminNavActive } from './adminMenuConfig';
import { useCompany } from '../../context/CompanyContext';
import { useSecurity } from '../../context/SecurityContext';
import { filterAdminMenuByRole, normalizeAdminRoleCode } from '../../utils/adminPermissions';
import BrandLogoMark from '../BrandLogoMark';

const AdminSidebar = ({ isOpen, onClose, pathname }) => {
  const navigate = useNavigate();
  const { companyName, logoUrl, company } = useCompany();
  const { adminUser } = useSecurity();
  const menuItems = filterAdminMenuByRole(ADMIN_MENU_ITEMS, normalizeAdminRoleCode(adminUser?.role));
  const logoHeight = Math.min(Number(company?.logo_height) || 36, 44);
  const logoWidth = Math.min(Number(company?.logo_width) || 64, 72);

  const handleVerTienda = () => {
    onClose();
    navigate('/catalogo');
  };

  const railContent = (
    <>
      <Link to="/admin/dashboard" className="adm-rail-logo" title={companyName || 'Panel'} onClick={onClose}>
        {logoUrl ? (
          <img
            src={logoUrl}
            alt={companyName || 'Logo empresa'}
            className="adm-rail-logo-img"
            style={{ maxHeight: logoHeight, maxWidth: logoWidth, objectFit: 'contain' }}
          />
        ) : (
          <BrandLogoMark className="adm-rail-logo-mark np-logo-mark-svg" />
        )}
      </Link>

      <nav className="adm-rail-nav" aria-label="Menú administración">
        {menuItems.map((item) => {
          const active = isAdminNavActive(pathname, item.path);
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`adm-rail-btn ${active ? 'adm-rail-btn--active' : ''}`}
              title={item.label}
              aria-label={item.label}
              onClick={onClose}
            >
              <i className={`bi ${item.icon}`} />
            </Link>
          );
        })}
      </nav>

      <div className="adm-rail-footer">
        <button
          type="button"
          className="adm-rail-btn adm-rail-btn--muted"
          onClick={handleVerTienda}
          title="Ver tienda"
        >
          <i className="bi bi-shop" />
        </button>
      </div>
    </>
  );

  return (
    <>
      <div className={`adm-mobile-backdrop d-md-none ${isOpen ? 'is-open' : ''}`} onClick={onClose} aria-hidden />
      <aside className={`adm-rail d-none d-md-flex flex-column ${isOpen ? '' : ''}`}>
        {railContent}
      </aside>
      <aside className={`adm-rail adm-rail--drawer d-md-none flex-column ${isOpen ? 'is-open' : ''}`}>
        {railContent}
      </aside>
    </>
  );
};

export default AdminSidebar;
